import { API_STATES } from '@/helpers'

const state = {
  userEmailVerification        : {},
  userEmailVerificationState   : API_STATES.NOT_REQUESTED,
  userEmailVerificationErr     : null,
  resendEmailVerificationState : API_STATES.NOT_REQUESTED,
  resendEmailVerificationErr   : null,
  onboardingSignupState        : API_STATES.NOT_REQUESTED,
  onboardingSignupErr          : null,
  userSignupState              : API_STATES.NOT_REQUESTED,
  userSignupErr                : null,
  verifyEmailState             : API_STATES.NOT_REQUESTED,
  verifyEmailErr               : null,
  importUserState              : API_STATES.NOT_REQUESTED,
  importUserErr                : null
}

export default state
